package com.milta.core.localization

data class HomeStrings(
    val navTournee: String,
    val navEcoDriving: String,
    val navCommunity: String,
    val navRewards: String,
    val navHome: String,
    val navRoutes: String,
    val navTeam: String,
    val navProfile: String,
    /** Tab 0 label for Enterprise-mode accounts (Écran 12 mockup) — distinct from [navHome] used in Driver mode. */
    val navDashboard: String,
)
